import React from 'react';

export const PdpSharedSellerTabsVariantLazy = React.lazy(() =>
    import(/* webpackChunkName: "PdpSharedContactTabsVariant" */ './PdpSharedSellerTabsVariant')
);
